module.exports = __webpack_public_path__ + "static/media/ipad-right-img.4d5baade.jpg";